import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

/**
 * Display the incident icon (flag) with status-based color:
 * danger for OPEN/IN_PROGRESS, secondary (muted) for CLOSED.
 * If the incident is restricted, a lock icon is displayed on top of the flag.
 */
import SRoundedIcon, { type SRoundedProps } from '@/components/SRoundedIcon/SRoundedIcon.vue';
import { IncidentLightDto } from '@/api';

type IncidentIconSize = SRoundedProps['size'];

export interface Props {
  size?: IncidentIconSize;
  status?: IncidentLightDto.status;
  restricted?: boolean;
}






const LOCK_CUTOUT_SRC = '/icons/svg/lock-filled-closed-cutout.svg'
const LOCK_FILLED_SRC = '/icons/svg/lock-filled-closed.svg'
const DECORATIVE_IMG_ALT = ''

export default /*#__PURE__*/_defineComponent({
  __name: 'IncidentIcon',
  props: {
  size: { default: 'medium' },
  status: null,
  restricted: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;


const isClosed = _computed(() => props.status === 'CLOSED');
const backgroundColor = _computed(() => (isClosed.value ? 'bgTertiary' : 'bgDangerSecondary'));
const borderColor = _computed(() => (isClosed.value ? 'textTertiary' : 'borderDanger'));
const flagIconColor = _computed(() => (isClosed.value ? 'textSecondary' : 'textDanger'));

return { __sfc: true,LOCK_CUTOUT_SRC, LOCK_FILLED_SRC, DECORATIVE_IMG_ALT, props, isClosed, backgroundColor, borderColor, flagIconColor, _computed, SRoundedIcon, IncidentLightDto }
}

})